import React from "react";
import { Link } from "react-router-dom";
import LogoImg1 from "../../assets/images/icon-logo-cropped.png";
import LogoImg2 from "../../assets/images/text-logo-cropped.png";

const Logo = ({ showIconLogo = false, style = {} }) => {
  const defaultStyle = {
    width: showIconLogo ? "50px" : "190px",
    height: "auto",
    objectFit: "contain",
    ...style, // overrides default if provided
  };

  return (
    <div className="logo">
      <Link to="/">
        <img
          src={showIconLogo ? LogoImg1 : LogoImg2}
          alt="Logo"
          style={defaultStyle}
        />
      </Link>
    </div>
  );
};

export default Logo;
